import Avatar from 'components/base/Avatar';
import { useState } from 'react';
import { Card, Dropdown, Nav } from 'react-bootstrap';
import avatar from 'assets/img/team/72x72/57.webp';
import FeatherIcon from 'feather-icons-react';
import { Link, useNavigate } from 'react-router-dom';
import Scrollbar from 'components/base/Scrollbar';
import classNames from 'classnames';
import { useAuth } from 'providers/AuthProvider';

const ProfileDropdownMenu = ({ className }: { className?: string }) => {
  const navigate = useNavigate();
  const { logout, state } = useAuth();
  const { user, isLoading } = state;

  const [navItems] = useState([
    {
      label: 'Perfil',
      icon: 'user'
    },
    {
      label: 'Dashboard',
      icon: 'pie-chart'
    },
    {
      label: 'Privacidade ',
      icon: 'settings'
    }
  ]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/pages/authentication/split/sign-out');
    } catch (error) {
      console.error('Logout failed:', error);
      // Even if API call fails, still navigate to sign-out
      navigate('/pages/authentication/split/sign-out');
    }
  };
  return (
    <Dropdown.Menu
      align="end"
      className={classNames(
        className,
        'navbar-top-dropdown-menu navbar-dropdown-caret py-0 dropdown-profile shadow border border-300'
      )}
    >
      <Card className="position-relative border-0">
        <Card.Body className="p-0">
          <div className="d-flex flex-column align-items-center justify-content-center gap-2 pt-4 pb-3">
            <Avatar src={avatar} size="xl" />
            <h6 className="text-black">{user?.name || 'User'}</h6>
          </div>
          <div style={{ height: '8rem' }}>
            <Scrollbar>
              <Nav className="nav flex-column mb-2 pb-1">
                {navItems.map(item => (
                  <Nav.Item key={item.label}>
                    <Nav.Link href="#!" className="px-3">
                      <FeatherIcon
                        icon={item.icon}
                        size={16}
                        className="me-2 text-900"
                      />
                      <span className="text-1000">{item.label}</span>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Scrollbar>
          </div>
        </Card.Body>
        <Card.Footer className="p-0 border-top">
          <div className="px-3 py-3">
            <button
              type="button"
              onClick={handleLogout}
              className="btn btn-phoenix-secondary d-flex flex-center w-100"
              disabled={isLoading}
            >
              <FeatherIcon icon="log-out" className="me-2" size={16} />
              {isLoading ? 'Saindo...' : 'Sair'}
            </button>
          </div>
          <div className="my-2 text-center fw-bold fs-10 text-600">
            <Link className="text-600 me-1" to="#!" target="_blank">
              Política de privacidade
            </Link>
            <br />
            <Link className="text-600 mx-1" to="#!" target="_blank">
              Termos de uso
            </Link>
            <br />
            <Link className="text-600 ms-1" to="#!" target="_blank">
              Cookies
            </Link>
          </div>
        </Card.Footer>
      </Card>
    </Dropdown.Menu>
  );
};

export default ProfileDropdownMenu;
